import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import PortfolioSection from '../components/PortfolioSection';
import TestimonialSection from '../components/TestimonialSection';
import TeamSection from '../components/TeamSection';
import ContactSection from '../components/ContactSection';
import { useEffect } from 'react';

const Home = () => {
  useEffect(() => {
    document.title = 'CV Samudera Alam Perkasa - Solusi Tenaga Kerja Profesional';
  }, []);

  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <PortfolioSection />
      <TestimonialSection />
      <TeamSection />
      <ContactSection />
    </>
  );
};

export default Home;